import { capitalizeFirstLetter } from "./letter";

const extractCurrentPath = (location: any) => {
    const segments = location.pathname
        .split("/")
        .filter(Boolean)
        .flatMap((item: any) => item.split("-"))
        .map((item: string) => capitalizeFirstLetter(item));

    const actionWords = ['Add', 'Edit'];
    const actionSegment = segments.find((seg: string) => actionWords.includes(seg));

    const filteredSegments = segments.filter((seg: string) => !actionWords.includes(seg));

    if (actionSegment) {
        return `${actionSegment} ${filteredSegments.join(" ")}`.trim();
    }

    return filteredSegments.join(" ").trim();
}

export {
    extractCurrentPath
}
